<template>
  <b-card no-body id="tabs-container">
    <!-- :::::::::::::::::::::::::::: NOTIFICADOR :::::::::::::::::::::::::::: -->
    <notificador-card />
    <b-tabs active-nav-item-class="font-weight-bold text-primary" card>
      <!-- :::::::::::::::::::::::::::: CLIENTE :::::::::::::::::::::::::::: -->
      <div v-if="isOpen('CLIENTE')">
        <cliente-tablist />
      </div>
      <!-- :::::::::::::::::::::::::::: FORNECEDOR :::::::::::::::::::::::::::: -->
      <div v-if="isOpen('FORNECEDOR')">
        <fornecedor-tablist />
      </div>
      <!-- :::::::::::::::::::::::::::: ARMAZEM :::::::::::::::::::::::::::: -->
      <div v-if="isOpen('ENTRADA')">
        <entrada-tablist />
      </div>
      <div v-if="isOpen('SAIDA')">
        <saida-tablist />
      </div>
      <div v-if="isOpen('ARMAZENADO')">
        <armazem-tablist />
      </div>
      <div v-if="isOpen('PRIORIDADE')">
        <prioridade-tablist />
      </div>
      <!-- :::::::::::::::::::::::::::: TRANSPORTE :::::::::::::::::::::::::::: -->
      <div v-if="isOpen('TRANSPORTE')">
        <transporte-tablist />
      </div>
      <!-- :::::::::::::::::::::::::::: EQUIPAMENTOS :::::::::::::::::::::::::::: -->
      <div v-if="isOpen('IMAGEM')">
        <imagem-tablist />
      </div>
      <div v-if="isOpen('EQUIPAMENTO')">
        <equipamento-tablist />
      </div>
      <!-- :::::::::::::::::::::::::::: INSPEÇÃO :::::::::::::::::::::::::::: -->
      <div v-if="isOpen('DOCUMENTO')">
        <documento-tablist />
      </div>
      <div v-if="isOpen('INSTRUMENTO')">
        <instrumento-tablist />
      </div>
      <div v-if="isOpen('PROFISSIONAL')">
        <profissional-tablist />
      </div>
      <div v-if="isOpen('CONSUMIVEL')">
        <consumivel-tablist />
      </div>
      <!-- :::::::::::::::::::::::::::: EQUIPES :::::::::::::::::::::::::::: -->
      <div v-if="isOpen('EQUIPE')">
        <equipe-tablist />
      </div>
      <!-- :::::::::::::::::::::::::::: SERVIÇOS :::::::::::::::::::::::::::: -->
      <div v-if="isOpen('ATIVIDADE')">
        <atividade-tablist />
      </div>
      <div v-if="isOpen('AVULSO')">
        <avulso-tablist />
      </div>
      <!-- :::::::::::::::::::::::::::: FATURAMENTO :::::::::::::::::::::::::::: -->
      <div v-if="isOpen('PRODUTO')">
        <produto-tablist />
      </div><div v-if="isOpen('FATURAMENTO')">
        <faturamento-tablist />
      </div>
    </b-tabs>
  </b-card>
</template>

<script>
import { useSgcqStore } from "@/stores/SgcqStore";
import Notificador from "../supports/Notificador";
import ClienteTabList from "@/components/tabs/ClienteTabList";
import FornecedorTabList from "@/components/tabs/FornecedorTabList";
import EntradaTabList from "@/components/tabs/EntradaTabList";
import SaidaTabList from "@/components/tabs/SaidaTabList";
import ArmazemTabList from "@/components/tabs/ArmazemTabList";
import PrioridadeTabList from "@/components/tabs/PrioridadeTabList";
import TransporteTabList from "@/components/tabs/TransporteTabList";
import ImagemTabList from "@/components/tabs/ImagemTabList";
import EquipamentoTabList from "@/components/tabs/EquipamentoTabList";
import EquipeTabList from "@/components/tabs/EquipeTabList";
import AtividadeTabList from "@/components/tabs/AtividadeTabList";
import AvulsoTabList from "@/components/tabs/AvulsoTabList";
import ProdutoTabList from "@/components/tabs/ProdutoTabList";
import FaturamentoTabList from "@/components/tabs/FaturamentoTabList";
import InstrumentoTabList from "./InstrumentoTabList";
import DocumentoTabList from "./DocumentoTabList";
import ProfissionalTabList from "./ProfissionalTabList";
import ConsumivelTabList from "./ConsumivelTabList";

export default {
  name: "SgcqTabsPanel",

  components: {
    "notificador-card": Notificador,
    "cliente-tablist": ClienteTabList,
    "fornecedor-tablist": FornecedorTabList,
    "entrada-tablist": EntradaTabList,
    "saida-tablist": SaidaTabList,
    "armazem-tablist": ArmazemTabList,
    "prioridade-tablist": PrioridadeTabList,
    "transporte-tablist": TransporteTabList,
    "imagem-tablist": ImagemTabList,
    "equipamento-tablist": EquipamentoTabList,
    "equipe-tablist": EquipeTabList,
    "atividade-tablist": AtividadeTabList,
    "avulso-tablist": AvulsoTabList,
    "produto-tablist": ProdutoTabList,
    "faturamento-tablist": FaturamentoTabList,
    "instrumento-tablist": InstrumentoTabList,
    "documento-tablist": DocumentoTabList,
    "profissional-tablist": ProfissionalTabList,
    "consumivel-tablist": ConsumivelTabList,
  },

  data() {
    return {};
  },

  methods: {
    isOpen(aba) {
      let temAba = false;
      this.abas.findIndex((value) => {
        if (value.tipo == aba) {
          temAba = true;
        }
      });
      return temAba;
    },
  },

  setup() {
    const store = useSgcqStore();
    return {
      store,
      abas: store.getAbas,
    };
  },
};
</script>

<style lang="scss" scoped>
#tabs-container {
  display: inline-block;
  width: 80%;
  vertical-align: top;
  overflow-x: hidden;
  min-width: 80%;
  height: 88vh;
  overflow-y: hidden;
  overflow-x: hidden;
}
</style>
